module.exports = __webpack_public_path__ + "img/feature_buy_zh.f10fbc78.png";